import classnames from 'classnames';
import { DateTime } from 'luxon';
import * as React from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import InputMask from 'react-input-mask';
import "react-widgets/styles.css";
import {
    Button, Card, Col, Collapse, FormFeedback, FormGroup, Input,
    Label, Nav, NavItem, NavLink, Row, TabContent, Table, TabPane
} from 'reactstrap';
import Swal from 'sweetalert2';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Address, City, County, getAllAddresses, Location, selectLocations, State } from '../../redux/AddressSlice';
import {
    Auditor, AuditorDetailsInput, AuditorReference, ContactInfo, createAuditor,
    getAllAuditorRequests, loadAuditor, saveAuditor, selectAuditor, selectPendingAuditors
} from '../../redux/AuditorSlice';
import { getAllAuditorsAsync, selectAuditors } from '../../redux/AuditorsSlice';
import { ConceptRef, DimensionalConceptRef } from '../../redux/ConceptSlice';
import { selectEntities } from '../../redux/EntitiesSlice';
import { MessageEvent as MEvent, respondCPAFirm } from '../../redux/EventsSlice';
import {
    addDeprecation, EditDeprecation, getDeprecationFor, getDeprecations,
    getEditableDeprecation
} from '../../redux/TaxonomyChangesSlice';
import {
    DtsConcept, getDeprecationDate, getDeprecationLabel, loadTaxonomyConcept, resetTaxonomyConceptState
} from '../../redux/TaxonomyConceptSlice';
import { ActiveTaxonomyVersionInfo, selectCurrentVersion, TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import phoneHelper from '../../utils/phoneHelper';
import utilityHelper, { StyledSelectableListItem } from '../../utils/utilityHelper';
import AddressEditor from './AddressEditor';
import AddressViewer from './AddressViewer';


export interface PendingAuditor {
    entityId: string;
    entityName: string;
    auditorName: string;
    street: string;
    pobox: string;
    cityId: string;
    zip: string;
    phoneNumber: string;
    email: string;
    extension: string | null;
    address: Address;
    code: string;
    isNew: boolean;
    rejectionReason: string;
    requestorId: string;
}

const AdminAuditorManager = (props: any) => {

    const dispatch = useAppDispatch();

    //selectors
    const locationSelector = useAppSelector(selectLocations);
    const entitiesSelector = useAppSelector(selectEntities);
    const pendingAuditorsSelector = useAppSelector(selectPendingAuditors);
    const existingAuditorsSelector = useAppSelector(selectAuditors);
    const auditorSelector: Auditor | null = useAppSelector(selectAuditor);
    const taxonomySelector: ActiveTaxonomyVersionInfo | null = useAppSelector(selectCurrentVersion);
    var deprecations: EditDeprecation[] = useAppSelector(getDeprecations);
    //local hooks
    const [versionedConcept, setVersionConcept] = React.useState<DtsConcept | null>(null);
    const [activeTab, setActiveTab] = React.useState<'AUDIT_FIRMS' | 'NEW_FIRM' | 'PENDING_FIRMS' | 'DEPRECATE_FIRMS'>('AUDIT_FIRMS');
    const [auditorNames, setAuditorNames] = React.useState<Array<PendingAuditor>>([]);

    const [rejectReason, setRejectReason] = React.useState<string>('');
    const [isRejectedMode, setIsRejectedMode] = React.useState<boolean>(false);
    const [isApproveRejectMode, setIsApproveRejectMode] = React.useState<boolean>(false);

    const [existingAuditor, setExistingAuditor] = React.useState<Auditor | null>(null);
    const [deprecationAuditorReference, setDeprecationAuditorReference] = React.useState<DtsConcept | null>(null);
    const [replacementAuditorReference, setReplacementAuditorReference] = React.useState<DtsConcept | null>(null);
    const [updateAuditor, setUpdateAuditor] = React.useState<Auditor | null>(null);
    const [existingAuditorOptionNodes, setExistingAuditorOptionNodes] = React.useState<Array<StyledSelectableListItem>>([]);
    const [existingAuditorOptionNodesDeprecation, setExistingAuditorOptionNodesDeprecation] = React.useState<Array<StyledSelectableListItem>>([]);
    const [existingAuditorOptionNodesSubstitution, setExistingAuditorOptionNodesSubstitution] = React.useState<Array<StyledSelectableListItem>>([]);
    const [autoReplace, setAutoReplace] = React.useState<boolean>(false);


    const [selectedAuditorNodeTitle, setSelectedAuditorNodeTitle] = React.useState<string>('');

    const [selectedAuditorName, setSelectedAuditorName] = React.useState<string>('');

    const [selectedDeprecationAuditor, setSelectedDeprecationAuditor] = React.useState<StyledSelectableListItem | undefined>();
    const [deprecationDate, setDeprecationDate] = React.useState<string | undefined>(undefined);
    const [deprecationReason, setDeprecationReason] = React.useState<string>('');

    //address hooks
    const [street, setStreet] = React.useState<string | null>(null);
    const [zipCode, setZipCode] = React.useState<string | null>(null);
    const [pobox, setPobox] = React.useState<string | null>(null);
    const [state, setState] = React.useState<string | null>(null);
    const [county, setCounty] = React.useState<string | null>(null);
    const [cityCode, setCityCode] = React.useState<string | null>(null);

    //contact info hooks
    const [phoneNumber, setPhoneNumber] = React.useState<string>("");
    const [formattedPhoneNumber, setFormattedPhoneNumber] = React.useState<string>("");
    const [email, setEmail] = React.useState<string>("");
    const [selectedAuditor, setSelectedAuditor] = React.useState<Auditor|null>(null);
    const [matchingAuditor, setMatchingAuditor] = React.useState<Auditor | null>(null);
    const [pendingMessage, setPendingMessage] = React.useState<string>("");
    const [currentPending, setCurrentPending] = React.useState<PendingAuditor | null>(null);

    //tabulator hooks
    var tabulatorRef = React.useRef<any>(null);

    //concept hooks
    const emptyDeprecation = { conceptId: "", deprecationDate: "", reason: "", replacements: [], replacementType: "", new: false, dirty: false };
    const [currentReplacement, setCurrentReplacement] = React.useState<DimensionalConceptRef | null>(null);




    const [selectedAuditorDeprecationDate, setSelectedAuditorDeprecationDate] = React.useState("");
    const [selectedAuditorDeprecationLabel, setSelectedAuditorDeprecationLabel] = React.useState("");
    const [deprecationDirty, setDeprecationDirty] = React.useState(false);
    const [selectedAuditorStatus, setSelectedAuditorStatus] = React.useState("");

    const PendingAuditorActionLinks = function (cell: any, formatterParams: any, onRendered: any) {
        const rowData: PendingAuditor = cell._cell.row.data;

        var approveButton = document.createElement("i");
        approveButton.innerHTML = "<i class='bi bi-check-circle-fill text-success' title='Approve auditor' style='margin-right: 2em;'></i> ";
        approveButton.onclick = (e) => { handleApprovePendingAuditorClick(rowData) };

        var rejectButton = document.createElement("i");
        rejectButton.innerHTML = "<i class='bi bi-trash-fill text-danger' title='Reject auditor' style='margin-right: 2em;'></i> ";
        rejectButton.onclick = (e) => { handleRejectPendingAuditorClick(rowData) };

        var updateButton = document.createElement("i");
        updateButton.innerHTML = "<i class='bi bi-check-circle-fill text-success' title='Update auditor' style='margin-right: 2em;'></i> ";
        updateButton.onclick = (e) => { handleUpdateAuditorClick(rowData) };

        var spanRow = document.createElement("span");

        if (rowData.isNew == true) {
            spanRow.insertAdjacentElement("afterbegin", approveButton);
        }
        else {
            spanRow.insertAdjacentElement("afterbegin", updateButton);
        }

        spanRow.insertAdjacentElement("afterbegin", rejectButton);
        
        return spanRow;
    }

    const pendingAuditorColumns = [
        {
            title: "Approve/Reject",
            formatter: PendingAuditorActionLinks,
        },
        {
            title: "Entity ID",
            field: "entityId"
        },
        {
            title: "Entity Name",
            field: "entityName"
        },
        {
            title: "Auditor Name",
            field: "auditorName"
        },
    ];

    const recursiveFindCity = (cityId: string, parent: Location | null, current: Location, results: City[]) => {
        if (current.level === "CITY") {
            if (current.code === cityId) {
                var state: State = {
                    name: "Florida",
                    code: "fl",
                    parent: null
                }
                var county: County = {
                    name: "na",
                    code: "na",
                    parent: state
                }
                if (!parent) {
                    state.name = "no state";
                    county.name = "no county";
                }
                else if (parent.level == 'STATE') {
                    state.name = parent.name;
                    state.code = parent.code;
                } else if( parent.level === "COUNTY" ) {
                    // Assume Florida for the state
                    county.name = parent.name;
                    county.code = parent.code;
                }
                var foundCity: City = {
                    name: current.name,
                    code: current.code,
                    parent: county
                }
                results.push(foundCity);
            }
            return;
        }
        if (current.children) {
            current.children.map(x => recursiveFindCity(cityId, current, x, results));
        }

    }
    const findCity = (cityId : string, roots: Location[]): City => {
        var results: City[] = [];
        roots.map(x => recursiveFindCity(cityId, null, x, results));
        if (results.length > 0) {
            return results[0];
        }
        return {
            name: (roots.length > 0) ? "not found" : "no locations",
            code: cityId,
            parent: null
        };

    }
    //functions need approve, reject etc...
    const toggle = (tab: any) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    const initPendingAuditorList = (locs: Location[]) => {
        if (pendingAuditorsSelector) {
            var pendingAuditorsList: Array<PendingAuditor> = [];
            pendingAuditorsSelector.map((x : MEvent) => pendingAuditorsList.push(getPendingAuditorFromMessageEvent(x, locs)));
            setAuditorNames(pendingAuditorsList);
        }
    }

    const initExistingAuditorListTree = (existingAuditors: Array<AuditorReference> | null, setList: any) => {

        if (existingAuditors) {
            let result: Array<StyledSelectableListItem> = [];
            let index: number = 0;

            for (var i = 0; i < existingAuditors.length; i++) {

                index = result.findIndex((element) => element.label == existingAuditors[i].name);

                if (index === -1) {
                    //parent node, create parent
                    result.push({
                        value: existingAuditors[i].code,
                        label: existingAuditors[i].name,
                        children: [],
                        checked: false,
                        disabled: true,
                        className: ""
                    })

                    index = result.findIndex((element) => element.label == existingAuditors[i].name);

                    result[index].children.push({
                        value: existingAuditors[i].code,
                        label: result[index].label + " Zip Code [" + existingAuditors[i].branchId + "]",
                        children: [],
                        checked: false,
                        disabled: false,
                        className: ""
                    });
                }
                else {
                    result[index].children.push({
                        value: existingAuditors[i].code,
                        label: result[index].label + " Zip Code [" + existingAuditors[i].branchId + "]",
                        children: [],
                        checked: false,
                        disabled: false,
                        className: ""
                    });
                }
            }

            result.forEach(element => {
                if (element.children.length == 1) {
                    element.children = [];
                    element.disabled = false;
                }
            })
            setList(result);
        }
    }
    const updateSelectedNode = function (nodeIdIn : string | null, itemList: StyledSelectableListItem[]) {
        //update selected values to be false
        var result: StyledSelectableListItem[] = [];
        var nodeId = nodeIdIn ? nodeIdIn : "n/a";
        console.log("updating", nodeId);
        itemList.forEach((element) => {
            var newChildren: StyledSelectableListItem[] = [];
            if (element.children) {
                element.children.map(child => newChildren.push({ ...child, checked: child.value === nodeId } ))
            }
            var newItem: StyledSelectableListItem = { ...element, checked: element.value === nodeId, children : newChildren };
            result.push(newItem);
        });
        return result;
    }

    const onExistingAuditorOptionChange = (currentNode: any, selectedNodes: any): void => {

        var foundCurrentNodeIndex = existingAuditorOptionNodes.findIndex((element) => element.value == currentNode.value);
        if (foundCurrentNodeIndex) {
            if (selectedNodes.length > 0) {

                dispatch(loadAuditor(currentNode.value)).then((result : any) => {
                    var aud: any = result.payload;
                    setExistingAuditor(aud);
                });
            }
            else {

                //update selected values to be false
                dispatch(loadAuditor(null)).then((result: any) => { setExistingAuditor(null) });
            }
        }

    }

    const onDeprecateAuditorChange = (currentNode: any, selectedNodes: any): void => {
        var foundCurrentNodeIndex = existingAuditorOptionNodesDeprecation.findIndex((element) => element.value == currentNode.value);
        if (foundCurrentNodeIndex) {
            if (selectedNodes.length > 0) {

                var ref: ConceptRef = {
                    conceptId: "AuditorCode_" + currentNode.value,
                    taxonomyType: TaxonomyTypeEnum.AFR,
                    afrYear: versionedConcept && versionedConcept.year ? versionedConcept.year : 2022
                }

                dispatch(loadTaxonomyConcept(ref)).then((result : any) => {
                    var deprecateAuditorRef: DtsConcept | null = result.payload;
                    setVersionConcept( deprecateAuditorRef );
                    setDeprecationAuditorReference(deprecateAuditorRef);
                });

            }
            else {
                //update selected values to be false
                setReplacementAuditorReference(null);
                dispatch(resetTaxonomyConceptState);
            }
        }
    }

    const onSubstituteAuditorChange = (currentNode: any, selectedNodes: any): void => {

        var foundCurrentNodeIndex = existingAuditorOptionNodesSubstitution.findIndex((element) => element.value == currentNode.value);
        if (foundCurrentNodeIndex) {
            if (selectedNodes.length > 0) {

                var ref: ConceptRef = {
                    conceptId: "AuditorCode_" + currentNode.value,
                    taxonomyType: TaxonomyTypeEnum.AFR,
                    afrYear: versionedConcept && versionedConcept.year ? versionedConcept.year : 2022
                }

                dispatch(loadTaxonomyConcept(ref)).then((result: any) => {
                    var substituteAuditorReference: DtsConcept | null = result.payload;
                    setReplacementAuditorReference(substituteAuditorReference);
                });
            }
            else {
                console.log("setting null a");
                //update selected values to be false
                setReplacementAuditorReference(null);

                dispatch(resetTaxonomyConceptState);
            }
        } else {
            console.log("setting null b");
            //update selected values to be false
            setReplacementAuditorReference(null);

            dispatch(resetTaxonomyConceptState);
        }
    }

    const getPendingAuditorFromMessageEvent = (message: MEvent, locs: Location[]): PendingAuditor => {
        var stringParts = message.connector.split(",");
        var entityReference = entitiesSelector.find((element: any) => element.code == stringParts[0]);
        var idx = message.message.body.indexOf('{');
        // This is a default for responses that do not have the original JSON
        var mbody: any = {
            auditorName: "na",
            address: {},
            contactInfo: {},
            isNew: false
        };
        if (idx < 0) {
            // There is not json in the body
        } else {
            mbody = JSON.parse(message.message.body.substring(idx));
            if (!mbody.hasOwnProperty("address")) {
                mbody["address"] = {};
            }
            if (!mbody.hasOwnProperty("contactInfo")) {
                mbody["contactInfo"] = {};
            }
        }
        var zip = mbody.address ? mbody.address.zip : null;
        var pendingCode = createAuditorCode(mbody.name, zip);
        var matchedAuditors: Auditor[] = existingAuditorsSelector.filter(function (x: Auditor) { return x.code === pendingCode });
        var noMatch = (matchedAuditors.length === 0);
        var result: PendingAuditor = {
            auditorName: mbody.name,
            entityId: stringParts[0],
            entityName: entityReference && entityReference.name ? entityReference.name : '',
            street: mbody.address.street,
            pobox: mbody.address.pobox,
            cityId: mbody.address.cityId,
            zip: mbody.address.zip,
            phoneNumber: mbody.contactInfo.phoneNumber,
            email: mbody.contactInfo.email,
            extension: mbody.contactInfo.extension,
            address: createAddress(mbody.address.cityId, mbody.address.street, mbody.address.pobox, mbody.address.zip, locs),
            code: pendingCode,
            isNew: noMatch,
            rejectionReason: "",
            requestorId: message.creator.login
        }
        return result;
    }

    const resetApprovalViewState = () => {
        setIsRejectedMode(false);
        setIsApproveRejectMode(false);
        setRejectReason('');
    }

    const resetModifyViewState = () => {
        setSelectedAuditorName('');
        setPhoneNumber('');
        setEmail('');
        setStreet(null);
        setZipCode(null);
        setPobox(null);
        setState(null);
        setCounty(null);
        setCityCode(null);
        console.log("reset");
        dispatch(loadAuditor(null));
    }

    const initAuditorDetailFields = () => {
        if (auditorSelector) {
            setSelectedAuditorName(auditorSelector.name);
            setPhoneNumber("");
            setFormattedPhoneNumber("");
            setEmail("");
            if (auditorSelector.info) {
                if (auditorSelector.info.number) {
                    setPhoneNumber(auditorSelector.info.number.number);
                    setFormattedPhoneNumber(phoneHelper.formatPhoneNumber(auditorSelector.info.number.number) + (auditorSelector.info.number.extension ? ", ext: " + auditorSelector.info.number.extension : ""));
                }
                setEmail(auditorSelector.info.email);
            }
            setSelectedAuditorNodeTitle(auditorSelector.name);
            if (auditorSelector.address) {
                if (auditorSelector.address.street) {
                    setStreet(auditorSelector.address.street);
                }
                if (auditorSelector.address.zip) {
                    setZipCode(auditorSelector.address.zip);
                }
                if (auditorSelector.address.pobox) {
                    setPobox(auditorSelector.address.pobox);
                }
                if (auditorSelector.address.city &&
                    auditorSelector.address.city.code) {
                    setCityCode(auditorSelector.address.city.code);
                }
                setState(null);
                setCounty(null);
            }
            else {
                setStreet(null);
                setZipCode(null);
                setPobox(null);
                setState(null);
                setCounty(null);
                setCityCode(null);
            }
        }
    }

    const handleSaveAuditorClick = (e: any): void => {

        //update selected values to be false
        existingAuditorOptionNodes.forEach((element) => {
            element.checked = false;
            element.children.forEach((element) => { element.checked = false; })
        });

        let auditorToSave: AuditorDetailsInput = {
            name: selectedAuditorName,
            code: auditorSelector !== null ? auditorSelector.code : "",
            address: {
                cityId: cityCode ? cityCode : '',
                pobox: pobox ? pobox : '',
                street: street ? street : '',
                zip: zipCode ? zipCode : ''
            },
            //TODO change extension to be nullable
            contactInfo: { email: email, extension: null, phoneNumber: phoneNumber }
        }
        dispatch(saveAuditor(auditorToSave));
    }


    const handleApprovePendingAuditorClick = (auditor: PendingAuditor) => {

        var auditorByTaxonomy: { item1: number; item2: AuditorDetailsInput };

        let auditorToSave: AuditorDetailsInput = {
            name: auditor.auditorName,
            code: auditor.code,
            address: { cityId: auditor.cityId, pobox: auditor.pobox, street: auditor.street, zip: auditor.zip },
            contactInfo: { email: auditor.email, extension: auditor.extension, phoneNumber: auditor.phoneNumber }
        }

        auditorByTaxonomy = { item1: taxonomySelector !== null ? taxonomySelector.year : 0, item2: auditorToSave };
        dispatch(createAuditor(auditorByTaxonomy));
        var auditorRef: string = auditorToSave.name + " (" + auditorToSave.code + ") ";
        var entityAuditorResponse: { item1: string; item2: AuditorDetailsInput; item3: string, item4: string, item5: string };
        entityAuditorResponse = { item1: auditor.entityId, item2: auditorToSave, item3: "AUDITOR_APPROVAL", item4: auditorRef + " approved", item5: auditor.requestorId };
        dispatch(respondCPAFirm(entityAuditorResponse)).then((result: any) => {
            if (result.payload != null) {
                if (auditor.isNew) {
                    Swal.fire('A new Auditor (' + auditor.auditorName + ') has been created', '', 'info');
                } else {
                    Swal.fire('Existing Auditor (' + auditor.auditorName + ') has been updated', '', 'info');
                }
                dispatch(getAllAuditorsAsync());
            }
            else {
                Swal.fire('Oops...', 'Something went wrong!', 'error')
            }
        });
        setPendingMessage("");
        setRejectReason("");
        setSelectedAuditor(null);
        setCurrentPending(null);
        setActiveTab("AUDIT_FIRMS");
    }

    const handleUpdateAuditorClick = (auditor: PendingAuditor) => {

        let auditorToSave: AuditorDetailsInput = {
            name: auditor.auditorName,
            code: auditor.code,
            address: { cityId: auditor.cityId, pobox: auditor.pobox, street: auditor.street, zip: auditor.zip },
            contactInfo: { email: auditor.email, extension: auditor.extension, phoneNumber: auditor.phoneNumber }
        }
      
        dispatch(saveAuditor(auditorToSave));
        var auditorRef: string = auditorToSave.name + " (" + auditorToSave.code + ") ";
        var entityAuditorResponse: { item1: string; item2: AuditorDetailsInput; item3: string, item4: string, item5: string };
        entityAuditorResponse = { item1: auditor.entityId, item2: auditorToSave, item3: "AUDITOR_APPROVAL", item4: auditorRef + " approved", item5: auditor.requestorId };
        dispatch(respondCPAFirm(entityAuditorResponse)).then((result: any) => {
            if (result.payload != null) {
                if (auditor.isNew) {
                    Swal.fire('A new Auditor (' + auditor.auditorName + ') has been created', '', 'info');
                } else {
                    Swal.fire('Existing Auditor (' + auditor.auditorName + ') has been updated', '', 'info');
                }
                dispatch(getAllAuditorsAsync());
            }
            else {
                Swal.fire('Oops...', 'Something went wrong!', 'error')
            }
        });
        setPendingMessage("");
        setRejectReason("");
        setSelectedAuditor(null);
        setCurrentPending(null);
        setActiveTab("AUDIT_FIRMS");
    }

    const handleRejectPendingAuditorClick = (auditor: PendingAuditor) => {

        var entityAuditorResponse: { item1: string; item2: AuditorDetailsInput; item3: string, item4: string, item5: string };

        let auditorToSave: AuditorDetailsInput = {
            name: auditor.auditorName,
            code: auditor.auditorName.replace(/\s/g, '') + "_" + auditor.zip,
            address: { cityId: auditor.cityId, pobox: auditor.pobox, street: auditor.street, zip: auditor.zip },
            contactInfo: { email: auditor.email, extension: auditor.extension, phoneNumber: auditor.phoneNumber }
        }
        var rejectionMessage: string = "Reason: " + auditor.rejectionReason; // rejectReason
        entityAuditorResponse = { item1: auditor.entityId, item2: auditorToSave, item3: "AUDITOR_REJECTION", item4: rejectionMessage, item5: auditor.requestorId };
        dispatch(respondCPAFirm(entityAuditorResponse)).then((result: any) => {
            if (result.payload != null) {
                Swal.fire('Pending Auditor (' + auditor.auditorName + ') has been rejected', '', 'info');
            }
            else {
                Swal.fire('Oops...', 'Something went wrong!', 'error')
            }
        });
        setPendingMessage("");
        setRejectReason("");
        setSelectedAuditor(null);
        setCurrentPending(null);
        setActiveTab("AUDIT_FIRMS");
    }
    const createAuditorCode = (auditorName:string, shortZip : string ) =>
    {
        if (!auditorName) {
            return shortZip;
        }
        var auditorCodeName : string = auditorName.replace(/\&/g, "_amp_")
            .replace(/\;/g, "_semi_")
            .replace(/\+/g, "_plus_")
            .replace(/\:/g, "_colon_")
            .replace(/\,/g, "")
            .replace(/\'/g, "")
            .replace(/\./g, "")
            .replace(/\ /g, "");
        return auditorCodeName + "_" + shortZip;
    }

    const createAddress = function (cityId: string, str: string, po: string, z: string, locs: Location[]): Address {
        var city: City = findCity(cityId, locs);
        var addr: Address = {
            street: str,
            pobox: po,
            city: city,
            zip: z
        }
        return addr;
    }
    const generateAuditorReference = function(pAud: PendingAuditor) {
        return pAud.auditorName + " (" + pAud.address.zip + ")";
    }
    const handleRowClick = (e: any, row: any) => {
        var pAud: PendingAuditor = row.getData();
        setCurrentPending(pAud);
        setRejectReason(pAud.rejectionReason);

        if (pAud.isNew === true) {
            setPendingMessage("Approval will CREATE an Auditor - " + generateAuditorReference(pAud));
        } else {
            setPendingMessage("Approval will UPDATE an existing Auditor - " + generateAuditorReference(pAud));
        }
        var cinfo: ContactInfo = {
            email: pAud.email,
            number: {
                number: pAud.phoneNumber,
                extension: ""
            }
        }
        var pendingCode = createAuditorCode(pAud.auditorName, pAud.zip);
        var auditor: Auditor = {
            name: pAud.auditorName,
            code: pendingCode,
            branchId: pAud.zip,
            address: pAud.address,
            info: cinfo
        }
        setSelectedAuditor(auditor);
        var matchAuditors: Auditor[] = existingAuditorsSelector.filter(function (x: Auditor) { return x.code === pAud.zip });
        if (matchAuditors.length === 0) {
            setMatchingAuditor(null);
        } else {
            setMatchingAuditor(matchAuditors[0]);
        }

        //console.log(row.getData().auditorName);

    }
    const handleReasonChange = function (reason: string) {
        setRejectReason(reason);
        if (currentPending) {
            currentPending.rejectionReason = reason;
        }
    }
    const gridOptions = {

        rowClick: handleRowClick,

    }

    const getCurrentDeprecation = function (c: DtsConcept | null): EditDeprecation {
        if (!c || !c.concept) {
            return emptyDeprecation;
        }
        var concept = c.concept;
        var pendingDep: EditDeprecation | null = getDeprecationFor(deprecations, concept.id);
        if (!pendingDep) {
            if (c.concept.deprecation) {
                pendingDep = getEditableDeprecation(concept);
            } else {
                var deprecationDate: string | null = getDeprecationDate(concept);
                if (deprecationDate) {
                    var deprecationReason = getDeprecationLabel(concept);
                    if (!deprecationReason) {
                        deprecationReason = "";
                    }
                    // Make one up around the existing deprecation model
                    pendingDep = {
                        conceptId: concept.id,
                        reason: deprecationReason,
                        deprecationDate: deprecationDate,
                        replacements: [],
                        replacementType: "",
                        new: false,
                        dirty: false
                    }
                }
            }
        }
        if (!pendingDep) {
            return emptyDeprecation;
        }
        return pendingDep;
    }
    const [deprecation, setDeprecation] = React.useState<EditDeprecation>(getCurrentDeprecation(versionedConcept));

    const resetDeprecation = function () {
        console.log("reset start");
        setDeprecation(emptyDeprecation);
        setDeprecationDirty(false);
        setSelectedAuditorStatus("");
        setSelectedAuditorDeprecationDate("");
        setSelectedAuditorDeprecationLabel("");
        setDeprecationAuditorReference(null);
        setCurrentReplacement(null);
        setReplacementAuditorReference(null);
        console.log("reset");
    }

    const deprecateAuditorWithReplacement = function (audConceptId : string, audReplacement: DtsConcept | null) {
        var newReplacement: DimensionalConceptRef[] = [];
        var repType: string = autoReplace ? "autoReplace" : "";
        if (audReplacement && audReplacement.concept) {
            var newParent: DimensionalConceptRef = {
                conceptId: audReplacement.concept.id,
                dimensions: [],
                conceptName: "",
                taxonomyType: TaxonomyTypeEnum.AFR,
                afrYear: audReplacement.year
            };
            newReplacement.push(newParent);
        }
        var dep: EditDeprecation = {
            ...deprecation,
            conceptId: audConceptId,
            deprecationDate: deprecationDate,
            reason: deprecationReason,
            dirty: false,
            replacements: newReplacement,
            replacementType: repType
        };
        console.log("rep", audReplacement, "dep", dep);
        setDeprecation(dep);
        dispatch(addDeprecation(dep));

    }
    const deprecateAuditor = function(aud : DtsConcept | null) {
        if (!aud || !aud.concept) {
            return;
        }
        var audConceptId = aud.concept.id;

        console.log("dep with ref");
        deprecateAuditorWithReplacement(audConceptId, replacementAuditorReference);
    }

     const handleDeprecationAuditorClick = () => {
        if (!versionedConcept || !versionedConcept.concept) {
            return;
         }
         deprecateAuditor(versionedConcept);
    }

    const getAuditorReferenceCode = function (cref: DtsConcept | null) {
        var result: string | null = null;
        if (cref && cref.concept) {
            result = cref.concept.code;
        }
        return result;
    }

    React.useEffect(() => {
        console.log("atbbing");
        if (activeTab === 'PENDING_FIRMS') {
            resetApprovalViewState();
            dispatch(getAllAuditorRequests());
        }
        else if (activeTab === 'AUDIT_FIRMS') {
            dispatch(getAllAuditorsAsync());
            resetModifyViewState();
        }
        else if (activeTab === 'DEPRECATE_FIRMS') {
            dispatch(getAllAuditorsAsync());
        }
    }, [activeTab])

    React.useEffect(() => {
        console.log("changeauditors??")
        setVersionConcept(null);
        if (!existingAuditorsSelector || existingAuditorsSelector.length <= 0) {
            dispatch(getAllAuditorsAsync());
        }
        if (activeTab === 'AUDIT_FIRMS') {
            initExistingAuditorListTree(existingAuditorsSelector, setExistingAuditorOptionNodes);
        }
        else if (activeTab === 'DEPRECATE_FIRMS') {
            initExistingAuditorListTree(existingAuditorsSelector, setExistingAuditorOptionNodesDeprecation);
            initExistingAuditorListTree(existingAuditorsSelector, setExistingAuditorOptionNodesSubstitution);
        }
    }, [existingAuditorsSelector])

    React.useEffect(() => {
        console.log("pending");
        initPendingAuditorList(locationSelector);
    }, [pendingAuditorsSelector])

    React.useEffect(() => {
        if (auditorSelector) {
            initAuditorDetailFields();
        } else {
            setFormattedPhoneNumber("");
        }
    }, [auditorSelector])

    React.useEffect(() => {
        console.log("anything");
        if (locationSelector === null ||
            (locationSelector !== null && locationSelector.length === 0)
        ) {
            dispatch(getAllAddresses());
        }
    }, []);

    React.useEffect(() => {
        console.log("a names");
        tabulatorRef.current = new Tabulator('#adminAuditor', {
            data: auditorNames,
            columns: pendingAuditorColumns,
            layout: "fitColumns",
        }).on("rowClick", handleRowClick);

    }, [, auditorNames]);

    React.useEffect(() => {
        setExistingAuditorOptionNodes(updateSelectedNode(existingAuditor ? existingAuditor.code : null, existingAuditorOptionNodes));
    }, [existingAuditor]);

    React.useEffect(() => {
        setExistingAuditorOptionNodesDeprecation(updateSelectedNode(getAuditorReferenceCode(deprecationAuditorReference), existingAuditorOptionNodesDeprecation));
    }, [deprecationAuditorReference]);

    React.useEffect(() => {
        setExistingAuditorOptionNodesSubstitution(updateSelectedNode(getAuditorReferenceCode(replacementAuditorReference), existingAuditorOptionNodesSubstitution));
    }, [replacementAuditorReference]);

    const pendingAuditTemplate = (<React.Fragment><Row>
        <Col md="12">
            <Row>
                <Col md="12">
                    <Row>
                        <Col>
                            <h5>Pending Auditors</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div id="adminAuditor" ref={ele => { tabulatorRef.current = ele }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="7" >
                            <Label>{pendingMessage}</Label>
                        </Col>
                        <Col md="5">
                            <Label>Reason For Rejection</Label>
                            <Input type="textarea" value={rejectReason}
                                onChange={(e) => handleReasonChange(e.currentTarget.value)}
                                disabled={currentPending ? false : true}
                                />
                        </Col>
                    </Row>
                    <Row>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th colSpan={4} align={'center'}>Pending Auditor Information</th>
                                </tr>
                                <tr>
                                    <th>Firm Name</th>
                                    <th>Zip Code</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Address</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <Label>{selectedAuditor && selectedAuditor.name}</Label>
                                    </td>
                                    <td><Label>{selectedAuditor && selectedAuditor.branchId}</Label></td>
                                    <td>
                                        <Label>{selectedAuditor && selectedAuditor.info.number.number}</Label>
                                    </td>
                                    <td>
                                        <Label>{selectedAuditor && selectedAuditor.info.email}</Label>
                                    </td>
                                    <td>{selectedAuditor && selectedAuditor.address &&
                                        (<AddressViewer
                                            street={selectedAuditor.address.street}
                                            poBox={selectedAuditor.address.pobox} state={""}
                                            zipCode={selectedAuditor.address.zip}
                                            city={selectedAuditor.address.city != null ? selectedAuditor.address.city.name : ""} />)}
                                    </td>
                                </tr>

                            </tbody>
                        </Table>
                     </Row>
                    <Row>
                        <Col>
                            <DropdownTreeSelect
                                id="existing"
                                data={existingAuditorOptionNodes}
                                onChange={onExistingAuditorOptionChange}
                                mode={"radioSelect"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th colSpan={4} align={'center'}>Matched Auditor Information</th>
                                </tr>
                                <tr>
                                    <th>Firm Name</th>
                                    <th>Zip Code</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Address</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <Label>{auditorSelector && auditorSelector.name}</Label>
                                    </td>
                                    <td><Label>{auditorSelector && auditorSelector.branchId}</Label></td>
                                    <td>
                                        <Label>{formattedPhoneNumber}</Label>
                                    </td>
                                    <td>
                                        <Label>{auditorSelector && auditorSelector.info.email}</Label>
                                    </td>
                                    <td>{auditorSelector && auditorSelector.address &&
                                        (<AddressViewer
                                            street={auditorSelector.address.street}
                                            poBox={auditorSelector.address.pobox} state={""}
                                            zipCode={auditorSelector.address.zip}
                                            city={auditorSelector.address.city != null ? auditorSelector.address.city.name : ""} />)}
                                    </td>
                                </tr>

                            </tbody>
                        </Table>
                    </Row>
                </Col>
                <Col md="5">
                    <Collapse isOpen={isApproveRejectMode} style={{ marginTop: "2em" }}>
                        <Row>
                            <Col>


                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button style={{ marginBottom: "1em" }}
                                    onClick={(e) => { handleApprovePendingAuditorClick }}>
                                    Approve
                                </Button>
                            </Col>
                            <Col>
                                <Button style={{ marginBottom: "1em" }}
                                    onClick={(e) => { handleRejectPendingAuditorClick }}>
                                    Reject
                                </Button>
                            </Col>
                        </Row>
                    </Collapse>
                    <Collapse isOpen={isRejectedMode}>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label>Reasoning:</Label>
                                        </Col>
                                        <Col md="9">
                                            <Input type="textarea" value={rejectReason} rows="10"
                                                onChange={(e) => setRejectReason(e.currentTarget.value)}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button style={{ marginBottom: "1em" }} onClick={(e) => {

                                    setActiveTab("AUDIT_FIRMS");
                                    resetApprovalViewState();
                                }}>Save</Button>
                            </Col>
                            <Col>
                                <Button style={{ marginBottom: "1em" }} onClick={(e) => {
                                    setIsRejectedMode(false);
                                    setIsApproveRejectMode(true);

                                }}>Cancel</Button>
                            </Col>
                        </Row>
                    </Collapse>
                </Col>
            </Row>
        </Col>
    </Row></React.Fragment>)

    const existingAuditFirmTemplate = (<React.Fragment>
        <Row style={{ marginBottom: "1em" }}>
            <Col md="5">
                <h4>Current Auditors</h4>
            </Col>
            <Col md="7" hidden={!auditorSelector}>
                <h4>Details For {selectedAuditorNodeTitle}</h4>
            </Col>
        </Row>
        <Row>
            <Col md="5">
                <Row>
                    <Col>
                        <DropdownTreeSelect
                            id="existing"
                            data={existingAuditorOptionNodes}
                            onChange={onExistingAuditorOptionChange}
                            mode={"radioSelect"}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                </Row>
                <Collapse isOpen={auditorSelector != null}>
                    <Row style={{ marginTop: "5em" }}>
                        <Col>
                            <Button onClick={(e) => { handleSaveAuditorClick(e) }}>Save Auditor</Button>
                        </Col>
                        <Col><Button onClick={() => { resetModifyViewState() }} >Cancel</Button></Col>
                    </Row>
                </Collapse>
            </Col>
            <Col md="7">
                {auditorSelector ? (
                    <React.Fragment>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Row>
                                                <Col>
                                                    <Label>Audit Firm Name:</Label>
                                                </Col>
                                                <Col md="9">
                                                    <Input type="text"
                                                        value={selectedAuditorName}
                                                        onChange={(e) => { setSelectedAuditorName(e.currentTarget.value) }} />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label>Email:</Label>
                                        </Col>
                                        <Col md="9">
                                            <Input type="email"
                                                value={email || ''}
                                                onChange={(e) => setEmail(e.currentTarget.value)}
                                                valid={utilityHelper.isTextPresent(email)}
                                                invalid={!utilityHelper.isTextPresent(email)} />
                                            <FormFeedback>Email is required.</FormFeedback>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Row>
                                        <Col >
                                            <Label>Phone Number:</Label>
                                        </Col>
                                        <Col md="9">
                                            <Input
                                                type="tel"
                                                mask="(999) 999-9999"
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.currentTarget.value)}
                                                tag={InputMask}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <AddressEditor
                                            street={street}
                                            setStreet={setStreet}
                                            zipCode={zipCode}
                                            setZipCode={setZipCode}
                                            poBox={pobox}
                                            setPoBox={setPobox}
                                            cityCode={cityCode}
                                            setCityCode={setCityCode}
                                            county={county}
                                            setCounty={setCounty}
                                            state={state}
                                            setState={setState}
                                            canEdit={true}
                                            disableZipEditing={true}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </React.Fragment>
                ) : (<div></div>)}

            </Col>
        </Row>

    </React.Fragment>)

    const deprecateAuditFirmTemplate = (<React.Fragment>
        <Row>
            <Col >
                <h3>Deprecate Auditor</h3>
                <p>If you choose a replacement, you can also check the auto-replacement box to replace all references to the deprecated Auditor with the replacement</p>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Row>
                        <Col className="text-md-right" >
                        </Col>
                        <Col md="10">
                            <DropdownTreeSelect
                                id="deprecation"
                                data={existingAuditorOptionNodesDeprecation}
                                onChange={onDeprecateAuditorChange}
                                mode={"radioSelect"}
                                keepTreeOnSearch={true}
                                keepChildrenOnSearch={true}
                            />

                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col className="text-md-right" >
                            <Label><b>Date:</b></Label>
                        </Col>
                        <Col lg="10">

                            <Input type="date" value={deprecationDate}
                                onChange={(e) => { setDeprecationDate(e.currentTarget.value); }}
                                valid={DateTime.fromISO(deprecationDate).isValid
                                    && (activeTab == 'DEPRECATE_FIRMS')
                                    && utilityHelper.isTextPresent(deprecationDate)
                                    && deprecationDate != 'mm/dd/yyy'}
                                invalid={!DateTime.fromISO(deprecationDate).isValid
                                    && (activeTab == 'DEPRECATE_FIRMS')
                                    && (!utilityHelper.isTextPresent(deprecationDate)
                                        || deprecationDate == 'mm/dd/yyy')}
                                max={DateTime.now().toFormat('yyyy-LL-dd')}
                            />

                            <FormFeedback>Enter a valid date.</FormFeedback>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col className="text-md-right" >
                            <Label><b>Comments:</b></Label>
                        </Col>
                        <Col md="10">
                            <Input type="textarea" value={deprecationReason} rows="10"
                                onChange={(e) => setDeprecationReason(e.currentTarget.value)}
                                valid={utilityHelper.isTextPresent(deprecationReason) && (activeTab == 'DEPRECATE_FIRMS')}
                                invalid={!utilityHelper.isTextPresent(deprecationReason) && (activeTab == 'DEPRECATE_FIRMS')}
                            />
                            <FormFeedback>Comment required.</FormFeedback>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col className="text-md-right" >
                            <Label><b>Substitutions:</b></Label>
                        </Col>
                        <Col md="10">
                            <DropdownTreeSelect
                                id="substitution"
                                data={existingAuditorOptionNodesSubstitution}
                                onChange={onSubstituteAuditorChange}
                                mode={"radioSelect"}
                                keepTreeOnSearch={true}
                                keepChildrenOnSearch={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col md="10">
                            <Label style={{ marginLeft: "2em" }}>
                                <Input type='checkbox'
                                    disabled={replacementAuditorReference == null}
                                    defaultChecked={false}
                                    checked={autoReplace}
                                    onChange={(e) => {
                                        setAutoReplace(e.target.checked);
                                    }}
                                />Automatically Replace Decremented Auditor In Current AFRs
                            </Label>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col className="text-md-right" >
                        </Col>
                        <Col md="10">
                            <Button
                                style={{ marginRight: "2em" }}
                                onClick={() => { handleDeprecationAuditorClick() }}>
                                Save Deprecation</Button>
                            <Button
                                style={{ marginRight: "2em" }}
                                onClick={() => { resetDeprecation() }}>Cancel Deprecation</Button>
                        </Col>
                    </Row>
                </FormGroup>
            </Col>
        </Row>

    </React.Fragment>)


    return (
        <React.Fragment>
            <Row style={{ marginBottom: "2em" }}>
                <Col md="12">
                    <h2>Auditor Management {taxonomySelector ? "(" + taxonomySelector.year + ")" : ""}</h2>
                </Col>
            </Row>
            <Row>
                <Col md="2">
                    <Card body style={{ height: "100%" }}>
                        <Nav >
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 'AUDIT_FIRMS' })}
                                    onClick={() => { toggle('AUDIT_FIRMS'); }}>
                                    Firms
                                        </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 'PENDING_FIRMS' })}
                                    onClick={() => { toggle('PENDING_FIRMS'); }}>
                                    Review Pending Firms
                                        </NavLink>
                            </NavItem>

                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 'DEPRECATE_FIRMS' })}
                                    onClick={() => { toggle('DEPRECATE_FIRMS'); }}>
                                    Deprecate Firm
                                        </NavLink>
                            </NavItem>
                        </Nav>
                    </Card>
                </Col>
                <Col md="10">
                    <Card body style={{ height: "100%" }}>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="AUDIT_FIRMS">
                                {existingAuditFirmTemplate}
                            </TabPane>
                            <TabPane tabId="NEW_FIRM">
                                <Row>
                                    <Col>
                                        {/*<AuditorRequestManager*/}
                                        {/*    mode={"NEW_AUDITOR"}*/}
                                        {/*/>*/}
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="PENDING_FIRMS" on>
                                {pendingAuditTemplate}
                            </TabPane>
                            <TabPane tabId="DEPRECATE_FIRMS">
                                {deprecateAuditFirmTemplate}
                            </TabPane>
                        </TabContent>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );

}

export default AdminAuditorManager;